import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { BroadcastService } from './core/services/broadcast.service';
import { DeviceDetectorService } from 'ngx-device-detector';

@UntilDestroy()
@Component({
  selector: 'myapp-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent implements OnInit, OnDestroy
{
  @Input() showHeader = false;

  constructor(private router: Router,
              private broadcastService: BroadcastService,
              private deviceDetector: DeviceDetectorService) { }

  @HostListener('window:resize')
  onResize()
  {
    this.broadcastService.windowResize.next({ width: window.innerWidth, height: window.innerHeight } );
  }

  ngOnInit()
  {
    this.setBrowserAndPlatform();

    this.broadcastService.showHeader.pipe(untilDestroyed(this)).subscribe(show => setTimeout(() => this.showHeader = show, 1));
  }

  ngOnDestroy()
  {
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Helper Methods
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  private setBrowserAndPlatform()
  {
    const el = document.getElementsByTagName('html')[0];

    let attr = document.createAttribute('browser-name');
    attr.value = this.deviceDetector.getDeviceInfo().browser.toLowerCase();
    el.attributes.setNamedItem(attr);

    attr = document.createAttribute('browser-version');
    attr.value = this.deviceDetector.getDeviceInfo().browser_version;
    el.attributes.setNamedItem(attr);

    attr = document.createAttribute('platform');
    attr.value = this.deviceDetector.getDeviceInfo().os;
    el.attributes.setNamedItem(attr);

    attr = document.createAttribute('is-mobile');
    attr.value = this.deviceDetector.isMobile() || this.deviceDetector.isTablet() ? 'true' : 'false';
    el.attributes.setNamedItem(attr);
  }
}
